import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const ArrowDownIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "ArrowDownIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        d="M19 13.0322C19 13.2257 18.9258 13.4192 18.7774 13.5669L12.5371 19.7785C12.2404 20.0738 11.7596 20.0738 11.4629 19.7785L5.22257 13.5669C4.92581 13.2715 4.92581 12.7929 5.22257 12.4975C5.51933 12.2021 6.00007 12.2021 6.29683 12.4975L12 18.1745L17.7032 12.4975C17.9999 12.2021 18.4807 12.2021 18.7774 12.4975C18.9258 12.6452 19 12.8387 19 13.0322Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12.7592 4.75621L12.7592 19.2438C12.7592 19.6613 12.4189 20 11.9995 20C11.5801 20 11.2398 19.6613 11.2398 19.2438L11.2398 4.7562C11.2398 4.33872 11.5801 4 11.9995 4C12.4189 4 12.7592 4.33873 12.7592 4.75621Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default ArrowDownIcon;
